import React from 'react'

import bath1 from '../../assets/showers/shower1.jpg'
import bath2 from '../../assets/showers/shower2.jpg'
import bath3 from '../../assets/showers/shower3.jpg'
import bath4 from '../../assets/showers/shower4.JPG'
import bath5 from '../../assets/showers/shower5.JPG'
import bath6 from '../../assets/showers/shower6.JPG'
import bath7 from '../../assets/showers/shower7.JPG'
import bath8 from '../../assets/showers/shower8.JPG'
import bath9 from '../../assets/showers/shower9.JPG'
import bath10 from '../../assets/showers/shower10.JPG'
import bath11 from '../../assets/showers/shower11.JPG'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination, Navigation,Autoplay } from 'swiper/modules';
function Bathroom() {
  return (
    <>
    <div className='wavy-hero-container'>
                    <img src={bath1} className='wavy-hero-img' alt='hero'/>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className='hero-wave'><path fill="var(--dark)" fill-opacity="1" d="M0,288L80,277.3C160,267,320,245,480,245.3C640,245,800,267,960,272C1120,277,1280,267,1360,261.3L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className='hero-wave-1'><path fill="#f6f6f6" fill-opacity="1" d="M0,288L80,277.3C160,267,320,245,480,245.3C640,245,800,267,960,272C1120,277,1280,267,1360,261.3L1440,256L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"></path></svg>
                    <div className='wavy-title'>
                        <p id='services' data-aos="slide-right">SERVICES</p>

                        <p data-aos="slide-left">BATHROOM REMODELING</p>
                    </div>
    </div>








    <div className='service-intro'>
        <div className='service-intro-container'>
            <div className='service-intro-text'>
                <div data-aos="fade-right" className='service-intro-text-wrapper'>
                    <div className='service-intro-text-title'>The <b>MOST</b> Reliable Bathroom Remodeling In DFW </div>
                    <div className='service-intro-text-sub'>Over 50+ Electrical Remodeling Clients in DFW</div>
                    <div className='service-intro-text-p' >Transform your bathroom into a modern sanctuary of comfort and style with Home Service Experts, where exceptional craftsmanship and attention to detail bring your vision to life. Whether you’re seeking a complete renovation or subtle upgrades, we collaborate with you to design a space that reflects your personal taste and lifestyle. From contemporary vanities and premium fixtures to sleek, energy-efficient lighting, every detail is carefully selected to create a bathroom that’s both beautiful and functional.</div>
                    <a href='tel:+14697284201'>
                        <button className='service-intro-text-btn'>GET A QUOTE</button>
                    </a>
                </div>
            </div>
            <img src={bath2} data-aos="fade-left" style={{"objectPosition":"top"}} alt='panel'/>
        </div>
    </div>









    <div className='service-cards'>
        <p className='service-cards-title' data-aos="fade">Electrical Services <span className='service-cards-accent'>Tailored to Your Home</span></p>
        <p className='service-cards-subtitle' data-aos="fade">Discover The Many Ways Our Electrical Services Can Improve Your Home</p>
        <div className='service-cards-wrapper'>

            <div className='service-cards-card' data-aos="flip-right">
                <img src={bath3} alt='card 1'/>


                <div className='service-cards-card-title'>
                    Complete Bathroom Remodeling: Transforming Everyday Spaces into Luxury Retreats

                </div>
                <div className='service-cards-card-subtitle'>
                    Your Dream Bathroom Starts Here
                </div>

                <div className='service-cards-card-p'>
                    At Home Service Experts, we specialize in full-scale bathroom renovations that blend comfort, elegance, and practicality. From reimagining layouts and upgrading plumbing to installing modern fixtures and lighting, we handle every detail with precision. Whether you’re looking to refresh your current space or start from scratch, our experts deliver results that elevate your home’s beauty, value, and functionality.

                </div>
            </div>



            <div className='service-cards-card' data-aos="flip-right">
                <img src={bath4} alt='card 2'/>

                <div className='service-cards-card-title'>
                    Custom Shower & Tub Installations: Designed for Comfort, Built for Style
                </div>

                <div className='service-cards-card-subtitle'>
                    Experience the Perfect Balance of Luxury and Relaxation
                </div>

                <div className='service-cards-card-p'>
                    Indulge in a spa-like experience with our custom shower and tub solutions. We offer a variety of modern designs—from sleek walk-in showers with frameless glass to freestanding soaking tubs that make a statement. Every installation is tailored to your style and space, using premium materials that ensure lasting quality and easy maintenance. With Home Service Experts, your bath area becomes the ultimate place to unwind.
                </div>
            </div>




            <div className='service-cards-card' data-aos="flip-right">
                <img src={bath5} alt='card 3'/>
                <div className='service-cards-card-title'>Vanities, Flooring & Lighting Upgrades: Details That Define Your Space</div>
                <div className='service-cards-card-subtitle'>
                    Function Meets Sophisticated Design
                </div>
                <div className='service-cards-card-p'>
                    Elevate your bathroom’s ambiance with custom vanities, elegant flooring, and energy-efficient lighting that tie your design together. Our team helps you choose the perfect combinations of finishes, textures, and colors to create a cohesive, modern look. With careful attention to craftsmanship and materials, Home Service Experts ensures every detail enhances your comfort, efficiency, and everyday living experience.
                </div>
            </div>




        </div>
    </div>









    <div className='service-cta'>
        <div className='service-cta-container'>
            <div className='service-cta-text'>
                <div>
                    <p className='service-cta-text-title' data-aos="fade">Start Your Bathroom <b>Upgrade Today</b></p>
                    <p className='service-cta-text-subtitle' data-aos="fade">If you’re ready to remodel your home’s Bathroom, contact Home Service Experts today. Our team would be happy to discuss your project, answer your questions, and provide a free estimate to get things moving.</p>
                </div>
                <a href='tel:+14697284201'>
                    <button className='service-cta-text-button' data-aos="fade">CALL NOW</button>
                </a>
            </div>
            <img className="service-cta-image" alt='service' src={bath6}/>
        </div>
    </div>













    <div className='service-portfolio'>
        <div className='service-portfolio-header'>
            <div className='service-portfolio-header-title' data-aos="fade"><b>Real</b> Projects. <b>Real</b> Results.</div>
            <div className='service-portfolio-header-subtitle' data-aos="fade">Explore our recent bathroom remodeling projects and see how expert craftsmanship transforms everyday spaces into stunning retreats. Every bathroom we create is designed for comfort, style, and lasting quality—crafted to reflect modern living at its finest.</div>
        </div>
        <div className='service-portfolio-slides'>
            <Swiper
            breakpoints={{
                1200:{
                    slidesPerView: 3,
                  spaceBetween: 15
                },
                900:{
                    slidesPerView: 2

                },
                550:{
                    slidesPerView: 1,

                    spaceBetween: 15
                }
                ,
                0: {
                //   slidesPerView: 2,

                  spaceBetween: 5
                }
              }}
              freeMode={true}
              navigation={true}
              loop={true}
              autoplay={{
                delay: 5000, // Delay in milliseconds (3 seconds)
                disableOnInteraction: true, // Continue autoplay after user interactions
                pauseOnMouseEnter: true, // Pause autoplay on mouse hover
              }}
              modules={[FreeMode, Pagination, Navigation, Autoplay]}
              style={{padding:"20px"}} data-aos="zoom-in">
                <SwiperSlide>
                    <img src={bath1} alt='Bathroom gallery 1'/>
                </SwiperSlide>
                
                <SwiperSlide>
                    <img src={bath2} alt='Bathroom gallery 2'/>
                </SwiperSlide>

                <SwiperSlide>
                    <img src={bath3} alt='Bathroom gallery 3'/>
                </SwiperSlide>

                <SwiperSlide>
                    <img alt='Bathroom gallery 4' src={bath4}/>
                </SwiperSlide>
                
                <SwiperSlide>
                    <img alt='Bathroom gallery 5' src={bath5}/>
                </SwiperSlide>                
                
                <SwiperSlide>
                    <img alt='bathroom gallery 6' src={bath6}/>
                </SwiperSlide>                
                
                <SwiperSlide>
                    <img alt='bathroom gallery 7' src={bath7}/>
                </SwiperSlide>

                <SwiperSlide>
                    <img alt='bathroom gallery 8' src={bath8}/>
                </SwiperSlide>
                
                <SwiperSlide>
                    <img alt='bathroom gallery 9' src={bath9}/>
                </SwiperSlide>
                
                <SwiperSlide>
                    <img alt='bathroom gallery 10' src={bath10}/>
                </SwiperSlide>
                                
                <SwiperSlide>
                    <img alt='bathroom gallery 11' src={bath11}/>
                </SwiperSlide>

            </Swiper>
        </div>










    </div>




















    </>
  )
}

export default Bathroom